<template>
	<v-container fluid>
		<v-tabs centered grow icons-and-text color="primary" dark class="elevation-1">
			<v-tabs-slider color="red"></v-tabs-slider>

			<v-tab key="scantab" :to="{ name: 'historyscantab' }" light>
				Scan
				<v-icon dark>thumbs_up_down</v-icon>
			</v-tab>
			<v-tab key="listtab" :to="{ name: 'historylisttab' }" light>
				List
				<v-icon dark>list</v-icon>
			</v-tab>
			<v-tab key="savingstab" :to="{ name: 'historysavingstab' }" light>
				Benefit
				<v-icon dark>attach_money</v-icon>
			</v-tab>
		</v-tabs>

		<router-view></router-view>

		<v-snackbar v-model="disclaimer" bottom multi-line :timeout="0">
			Whilst every care is taken, loan transactions listed may be incomplete subject to the deletion of titles over time, or removal due to database retention limitations. eBook loans are not included.
			<v-btn color="pink" flat @click="disclaimer = false" >
				Close
			</v-btn>
		</v-snackbar>
	</v-container>
</template>

<script>
export default {
	name: 'History',
	data ( ) {
		return {
			disclaimer: true,
		}
	},
	created( ) {
		if ( !this.$store.state.patron.loggedIn ) {
			this.$router.push( { name: 'login' } );
			return;
		}
		if ( this.borrowingHistoryCount == 0 ) {
			this.updateBorrowingHistory( );
		}
	},
	computed: {
		borrowingHistoryCount( ) {
			return this.$store.getters[ 'patron/borrowingHistoryCount' ];
		},
		betaEnabled( ) {
			return this.$store.getters[ 'beta' ];
		}
	},
	watch: {
	},
	methods: {
		updateBorrowingHistory( ) {
			this.$store.dispatch( 'patron/updateBorrowingHistory' );
		}
	}
}
</script>
